import React from "react";
import { TableFooter as MUITableFooter, TableRow, TablePagination } from "@material-ui/core";

function TableFooter({articlesPerPage, articleCount, state, setState}) {
    return(
        <MUITableFooter>
            <TableRow>
                <TablePagination rowsPerPageOptions={[]} count={articleCount} rowsPerPage={articlesPerPage} page={state.pageIndex} onPageChange={(event, newPage) => setState({ ...state, pageIndex: newPage})} />
            </TableRow>
        </MUITableFooter>
    );
}

export default TableFooter;
